import { useCallback, useEffect, useState } from 'react'

import { css } from 'design'

export const useFullscreen = () => {
  const [fullscreenElement, setFullscreenElement] = useState(getFullscreenElement)

  const goFullscreen = useCallback((element) => {
    if (element) {
      const fn =
        element.requestFullscreen ||
        element.webkitRequestFullscreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullscreen
      if (fn) {
        fn.apply(element)
        element.classList.add(fullScreenStylesForSafari())
      }
    }
  }, [])

  const exitFullscreen = useCallback(() => {
    const element = getFullscreenElement()
    if (element) {
      const fn =
        document.exitFullscreen ||
        // eslint-disable-next-line
        // @ts-ignore
        document.webkitExitFullscreen ||
        // eslint-disable-next-line
        // @ts-ignore
        document.mozCancelFullScreen ||
        // eslint-disable-next-line
        // @ts-ignore
        document.msExitFullscreen
      if (fn) {
        const element = getFullscreenElement()
        element.classList.remove(fullScreenStylesForSafari())
        fn.apply(document)
      }
    }
  }, [])

  useEffect(() => {
    const onFullscreenChange = () => {
      const element = getFullscreenElement()
      if(!element) { // No elemnt, no longer in FUUULL SCREEN
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fullscreenElement?.classList.remove(fullScreenStylesForSafari()) // Use previous element
      }
      setFullscreenElement(getFullscreenElement())
    }
    const eventNames = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'msfullscreenchange',
    ]
    eventNames.forEach((eventName) => {
      window.addEventListener(eventName, onFullscreenChange)
    })

    return () => {
      eventNames.forEach((eventName) => {
        window.removeEventListener(eventName, onFullscreenChange)
      })
    }
  }, [fullscreenElement])

  return {
    goFullscreen,
    exitFullscreen,
    fullscreenElement,
  }
}

const getFullscreenElement = () => {
  return (
    document.fullscreenElement ||
    // eslint-disable-next-line
    // @ts-ignore
    document.webkitFullscreenElement ||
    // eslint-disable-next-line
    // @ts-ignore
    document.mozFullScreenElement ||
    // eslint-disable-next-line
    // @ts-ignore
    document.msFullscreenElement
  )
}

const fullScreenStylesForSafari = css({
  width: '100vw !important',
  height: '100vh !important',
})
